import WeekMenu from "../modules/lunchMenu/WeekMenu";
import TodaysPhoto from "../modules/lunchMenu/TodaysPhoto";
import styled from "styled-components";
import { getISOWeekNumber } from "../utils/getISOWeekNumber";
import WeekMenuPreview from "../modules/lunchMenu/WeekMenuPreview";

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

const MenuWrapper = styled.div`
  flex: 3;
`;
const SimpleMenuWrapper = styled.div`
  padding: 2rem;
  flex-shrink: 1;
  max-height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const PhotoWrapper = styled.div`
  flex: 2;
  margin-left: 20px;
`;

function LunchMenu({ styled = "full" }) {
  const currentWeekNumber = getISOWeekNumber();

  const full = styled === "full";
  const simple = styled === "simple";

  return (
    <>
      {full ? (
        <Container>
          <MenuWrapper>
            <WeekMenuPreview/>
          </MenuWrapper>
          <PhotoWrapper>
            <TodaysPhoto />
          </PhotoWrapper>
        </Container>
      ) : simple ? (
        <SimpleMenuWrapper>
          <WeekMenu weekNumber={currentWeekNumber} height="460px" />


        </SimpleMenuWrapper>
      ) : null}
    </>
  );
}

export default LunchMenu;
